import React from 'react'

import { Box, Card, CardContent, FormControlLabel, Link, Switch, Typography } from '@mui/material'

import { IProject } from '../../../api/Data'

const ContestAddonCard = ({ project, handleChange }: IProps) => {
  const toggleContest = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event, { name: 'enableContest', checked: event.target.checked })
  }

  return (
    <Card sx={{ boxSizing: 'border-box', height: '100%', width: '100%' }}>
      <CardContent>
        <Box display="flex" flexDirection="column" gap={1.5}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
            <Box>
              <Typography variant="h5" fontWeight="bold">
                Public Gallery
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ marginTop: 0.5 }}>
                Showcase selected contributor videos in a public gallery without changing this project’s submission
                workflow.
              </Typography>
            </Box>
            <FormControlLabel
              label={project.enableContest ? 'Enabled' : 'Disabled'}
              labelPlacement="start"
              control={<Switch checked={!!project.enableContest} onChange={toggleContest} />}
            />
          </Box>

          <Typography variant="body2" color="textSecondary">
            Want to host a contest? Turn on the gallery, then configure its rules, judging, voting and moderation.
          </Typography>

          {project.enableContest && (
            <Typography variant="body2">
              Configure these under{' '}
              <Link href={`/projects/${project.slug}/collaborate?tab=contest`}>Public Video Gallery</Link>.
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

interface IProps {
  project: IProject
  handleChange: (event: React.SyntheticEvent, data: any) => void
}

export default ContestAddonCard
